/**
 * Handles {@link com.inq.flash.client.data.MessageFields.TYPE_ASYNC_UNAUTH_TOKEN_INFO} message.
 * Verifies token that was received from server
 *
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.AsyncUnauthTokenInfoMessageHandler = function () {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(
		this,
		com.inq.flash.client.data.MessageFields.TYPE_ASYNC_UNAUTH_TOKEN_INFO
	);
};

$hxClasses.extend(
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,
	com.inq.flash.client.control.messagehandlers.AsyncUnauthTokenInfoMessageHandler,
	"com.inq.flash.client.control.messagehandlers.AsyncUnauthTokenInfoMessageHandler"
);

com.inq.flash.client.control.messagehandlers.AsyncUnauthTokenInfoMessageHandler.prototype.processMessage = function (message) {
	com.inq.flash.client.control.PersistenceManager.SetValue(
		CONVERSATION_ID,
		message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CONVERSATION_ID)
	);

	com.inq.flash.client.control.FlashPeer.verifyToken(
		message.getProperty(com.inq.flash.client.data.MessageFields.KEY_TOKEN_ID)
	);
};

/** @type {com.inq.flash.client.control.messagehandlers.AsyncUnauthTokenInfoMessageHandler} */
com.inq.flash.client.control.messagehandlers.AsyncUnauthTokenInfoMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.AsyncUnauthTokenInfoMessageHandler;
